/**
 * String → URL-safe slug. Algorithm matches the inline `createBrandSlug`
 * helpers in pages/MergeBrands.tsx and pages/PopulateBrands.tsx so brand
 * slugs computed here line up with existing brand records.
 */
export function slugify(str: string): string {
  return str
    // Decompose accents (é → e + combining mark) and strip the marks so
    // accented chars don't get dropped entirely by the [^\w\s-] strip
    // below. "Pénélope" → "penelope" (not "pnlope").
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    // Convert ampersand to " and " BEFORE stripping non-word chars.
    // Without this, "Lantern & Wren" would slugify to "lantern-wren"
    // instead of the conventional "lantern-and-wren", creating
    // persistent orphan catalog entries.
    .replace(/&/g, ' and ')
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Canonical id for a polish in the polishCatalog collection.
 * Uses `__` to separate the brand and name parts so each part is
 * unambiguously recoverable even when the brand or name contains hyphens.
 */
export function polishSlug(brand: string, name: string): string {
  return `${slugify(brand)}__${slugify(name)}`;
}

export function parsePolishSlug(
  slug: string
): { brandSlug: string; nameSlug: string } | null {
  const idx = slug.indexOf('__');
  if (idx === -1) return null;
  return {
    brandSlug: slug.slice(0, idx),
    nameSlug: slug.slice(idx + 2),
  };
}